export enum WEBVIEW_TYPE_ENTRY {
  KB_PAY = 'KB_PAY',
  TOSS = 'TOSS',
  WELLO = 'WELLO',
}
